import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsCounterType, PmsCounterType } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsCounterType>
    useData={usePmsCounterType}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
